export default "__VITE_ASSET__BtpFyDdE__"